import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from "@angular/core";
import { ChangeRecoveryNumberSuccessComponent } from "./change-recovery-number-success.component";


class ChangeRecoveryNumberSuccessFormSession implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    resolver: ComponentFactoryResolver;
    viewContainerRef: ViewContainerRef;
    ChangeRecoveryNumberSuccessComponentRef: ComponentRef<ChangeRecoveryNumberSuccessComponent>;

    constructor(formId: string, payload: object) {
        console.log('Inside change recovery number success form constructor');
        this.formId = formId;
        this.payload = payload;
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
        console.log('Change Recovery Number Form session started: ' + this.formId);
        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.resolver = (clientContext as any).resolver;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {
        console.log('Change Recovery Number Form session ended: ' + this.formId);
      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        console.log('Change Recovery Number Success Form session Input: ' + this.formId);
        const self = this;
        self.viewContainerRef.clear();
        const factory: ComponentFactory<ChangeRecoveryNumberSuccessComponent> = self.resolver.resolveComponentFactory(ChangeRecoveryNumberSuccessComponent);
        self.ChangeRecoveryNumberSuccessComponentRef = self.viewContainerRef.createComponent(factory);

        console.log('change recoveryNumberSuccessFormTs constructor payload:', this.payload);

        return new Promise((resolve, reject) => {
          self.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
              console.log('change recoveryNumberSuccessFormTs createFormInputSubmissionRequest SUCCESS payload: ', payload);
              self.submitBlock = null;
            } catch (e) {
              console.log('change recoveryNumberSuccessFormTs createFormInputSubmissionRequest ERROR payload: ', payload);
              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {
        console.log('change recoveryNumberSuccessFormTs onContinue for ' + this.formId + ' payload:', payload);
      }

      onError(payload: object): void {
        console.log('change recoveryNumberSuccessFormTs onError for ' + this.formId + ' payload:', payload);
      }

}

interface ActionsInPayload {
    [key: string]: any;
  }

export default ChangeRecoveryNumberSuccessFormSession;
